import OkrElCollapse from "./OkrCollapse.vue";

OkrElCollapse["install"] = function(Vue) {
  Vue.component(OkrElCollapse.name, OkrElCollapse);
};

export default OkrElCollapse;
